import { mergeAttributes, Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import type { Any } from "@/lib/types";
import { ProductEmbedEditor } from "../product-embed-editor";

export interface ProductEmbedOptions {
	HTMLAttributes: Record<string, Any>;
}

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		productEmbed: {
			/**
			 * Insert a product embed with the given product IDs
			 */
			setProductEmbed: (options: { productIds: string[] }) => ReturnType;
		};
	}
}

export const ProductEmbed = Node.create<ProductEmbedOptions>({
	name: "productEmbed",

	addOptions() {
		return {
			HTMLAttributes: {},
		};
	},

	group: "block",

	draggable: true,

	addAttributes() {
		return {
			productIds: {
				default: [],
				parseHTML: (element) => {
					const productIds = element.getAttribute("data-product-ids");
					return productIds ? JSON.parse(productIds) : [];
				},
				renderHTML: (attributes) => {
					return {
						"data-product-ids": JSON.stringify(attributes.productIds),
					};
				},
			},
		};
	},

	parseHTML() {
		return [
			{
				tag: "div[data-type='product-embed']",
			},
		];
	},

	renderHTML({ HTMLAttributes, node }) {
		return [
			"div",
			mergeAttributes(
				{
					"data-type": "product-embed",
					"data-product-ids": JSON.stringify(node.attrs.productIds),
				},
				this.options.HTMLAttributes,
				HTMLAttributes,
			),
			0, // Empty content - rendering handled by React component
		];
	},

	addNodeView:
		typeof window === "undefined"
			? undefined
			: () => {
					return ReactNodeViewRenderer(ProductEmbedEditor);
				},

	addCommands() {
		return {
			setProductEmbed:
				(options) =>
				({ commands }) => {
					// Validate max 3 products
					if (options.productIds.length > 3) {
						console.warn("Maximum 3 products allowed in product embed");
						return false;
					}

					console.log("ProductEmbed setProductEmbed options.productIds:", options.productIds);

					return commands.insertContent({
						type: this.name,
						attrs: {
							productIds: options.productIds,
						},
					});
				},
		};
	},
});
